import Select from 'react-select'
import 'react-select/dist/react-select.css'

import {connect} from 'react-redux'

import React, {Component} from 'react'
import {actions} from 'react-redux-form'

class FilteredDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        }
    }

    componentWillMount() {
        const {model, dispatch} = this.props;

        dispatch(actions.change(model, this.props.value.value));
        this.setState({value: this.props.value});
    }

  componentWillReceiveProps(nextProps) {
    if(this.props.value.value !== nextProps.value.value){
      this.props.dispatch(actions.change(this.props.model, nextProps.value.value));
      this.setState({value: nextProps.value});
    }
  }

    handleChange(val) {
        const {model, dispatch} = this.props;
        this.setState({value: val});
        if(val == null) {
            dispatch(actions.change(model, ''))
        }
        else {
            dispatch(actions.change(model, val.value))
        }

        if(this.props.onChange && this.props.onChange !== undefined) {
            this.props.onChange(val);
        }

    }

    renderArrow = ({onMouseDown, isOpen}) => {
        if (isOpen) {
            return (
                <i className="fa fa-angle-up"/>
            )
        } else {
            return (
                <i className="fa fa-angle-down"/>
            );
        }

    };

    render() {
        const {data, placeholder} = this.props;
        return (
            <Select placeholder={placeholder}
                         value={this.state.value}
                        arrowRenderer={this.renderArrow}
                         options={data}
                         onChange={(option) => this.handleChange(option)}
            />
        )
    }
}

export default connect()(FilteredDropDown);


// WEBPACK FOOTER //
// ./src/components/common/form/filtered-dropdown.jsx